module.exports = __webpack_public_path__ + "img/etisalat-logo.00905912.png";